import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { PNLStatementSchema } from "../../types"

type PNLStatementType = {
  date_start: string
  location_id: string
}
export function usePNLStatementList(params?: PNLStatementType) {
  const api = useApi()
  const [data, setData] = useState<PNLStatementSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: PNLStatementType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/dashboard/pnl-statemenet/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: PNLStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/dashboard/pnl-statemenet/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: PNLStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}